import { WorkerAction, WorkerActionError, WorkerFnParams } from '../wasm-git.worker.model';
import { FSAction } from './actions.enum';

export interface FSSyncAction extends WorkerAction {
  type: FSAction.Sync;
}

class FSSyncActionError extends WorkerActionError {}

export async function FSSyncActionFn({ util }: WorkerFnParams<FSSyncAction>): Promise<void> {
  try {
    await util.syncfs(false);
  } catch (err) {
    throw new FSSyncActionError(err);
  }
}
